import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
} from '@mui/material';
import {Button, Typography} from '@fupa/fupa-uikit';
import React, {useState} from 'react';
import {sendEventToGA4} from 'app/helpers/gtagHelpers';

export const LivetickerAssignmentDialog = ({open, onClose, onAccept}) => {
  const [checked, setChecked] = useState(false);

  const handleChange = event => {
    setChecked(event.target.checked);
  };

  const handleCancel = () => {
    onClose();
    sendEventToGA4('assign_ticker_confirm_dialog', {assign_ticker_action: 'cancel'});
  };

  const handleAccept = () => {
    sendEventToGA4('assign_ticker_confirm_dialog', {assign_ticker_action: 'accept'});
    onAccept();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Liveticker wirklich übernehmen?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant='body1'>
            Du übernimmst das Eintragen aller Spielereignisse live. ✍️ <br />
            Sobald du als Liveticker-Melder eingetragen bist, kannst du den Liveticker nach Anpfiff des Spiels nicht
            mehr abgeben und führst den Liveticker bis zum Ende des Spiels durch.
          </Typography>
          <p />
          <FormControlLabel
            required
            control={<Checkbox onChange={handleChange} />}
            label='Ich bestätige, den Liveticker übernehmen zu wollen.'
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button justify='center' onClick={handleCancel} secondary text label='Abbrechen' />
        <Button justify='center' onClick={handleAccept} disabled={!checked} label='Bestätigen' />
      </DialogActions>
    </Dialog>
  );
};
